import type { Ref } from 'vue'

export function useClickOutside(
  target: Ref<HTMLElement | null>,
  handler: (event: MouseEvent) => void
) {
  const listener = (event: MouseEvent) => {
    const el = target.value

    if (!el || el === event.target || event.composedPath().includes(el)) {
      return
    }

    handler(event)
  }

  onMounted(() => document.addEventListener('click', listener))
  onBeforeUnmount(() => document.removeEventListener('click', listener))
}
